/**
 * Google Analytics Page Tracker Component
 * 
 * This component automatically tracks page views using Google Analytics 4.
 * It must be placed inside BrowserRouter to access route information.
 * 
 * The component renders nothing but handles all GA4 page view tracking.
 */

import useGoogleAnalytics from '../hooks/useGoogleAnalytics';

const GoogleAnalyticsTracker = () => {
  // This hook handles automatic page view tracking on route changes
  useGoogleAnalytics();
  
  // This component doesn't render anything visible
  return null;
};

export default GoogleAnalyticsTracker;
